/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1682985600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue May 02 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "elasticsearch",
        type: "source",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Connection configuration",
          "depth": 0,
          "id": "connection-configuration"
        }, {
          "value": "Test your connection",
          "depth": 0,
          "id": "test-your-connection"
        }, {
          "value": "Next steps",
          "depth": 0,
          "id": "next-steps"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      a: "a",
      strong: "strong",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components), {NoCommonErrors} = _components;
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you pull data stored in Elasticsearch using ", _jsx(_components.a, {
          href: "https://www.elastic.co/guide/en/elasticsearch/reference/current/xpack-sql.html",
          children: "Elasticsearch SQL"
        }), " and push it to downstream destinations. Most of the setup occurs in the Hightouch UI, but you need access to Elasticsearch for information like your host, port, and credentials."]
      }), "\n", _jsx(WhitelistDetails, {}), "\n", _jsx(_components.h2, {
        id: "connection-configuration",
        children: "Connection configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch supports connecting to your Elasticsearch clusters via optional ", _jsx(_components.a, {
          href: "https://www.elastic.co/guide/en/elasticsearch/reference/current/http-clients.html",
          children: "basic authentication"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["To get started, go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/sources",
          children: [_jsx(_components.strong, {
            children: "Sources"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add source"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Elasticsearch"
        }), " and enter the following fields into Hightouch:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Host"
          }), ": The hostname or IP address of your Elasticsearch server."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Port"
          }), ": The port number of your Elasticsearch server's HTTP API. The default is 9200, but yours may be different."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Username"
          }), ": This can be your personal Elasticsearch login or a dedicated user for Hightouch."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Password"
          }), ": The password for the user specified above."]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "test-your-connection",
        children: "Test your connection"
      }), "\n", _jsxs(_components.p, {
        children: ["When setting up Elasticsearch as a source for the first time, Hightouch checks that you have the correct permissions. Once the test passes, click ", _jsx(_components.strong, {
          children: "Continue"
        }), " to finish setup."]
      }), "\n", _jsx(_components.h2, {
        id: "next-steps",
        children: "Next steps"
      }), "\n", _jsxs(_components.p, {
        children: ["Once your source configuration has passed the necessary validation, your source setup is complete. Next, you can set up ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "models"
        }), " to define which data you want to pull from Elasticsearch."]
      }), "\n", _jsxs(_components.p, {
        children: ["The Elasticsearch source support writing queries in ", _jsx(_components.a, {
          href: "/models/sql-editor",
          children: "the SQL editor"
        }), " as its modeling method."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(NoCommonErrors, {
        source: "true"
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
